module.exports = __webpack_public_path__ + "img/icon _checkmark.b0b6e1d7.svg";